<template lang='pug' src='./financial-and-insurance.pug'></template>

<script>
import CustomFinancePage from 'components/custom/custom-finance-page/custom-finance-page'

export default {
  computed: {
    props () {
      return this.$store.state.pages['financial-and-insurance']
    }
  },
  components: {
    CustomFinancePage
  }
}
</script>



// WEBPACK FOOTER //
// financial-and-insurance.vue?328f7b19